/**
 * Sign Up Button Component
 *
 * Text button for anonymous users to trigger onboarding.
 * Replaces the profile icon when user is not authenticated.
 * Matches the clean, minimal aesthetic of the navbar.
 */

"use client";

interface SignUpIconProps {
  className?: string;
  onClick?: () => void;
}

export function SignUpIcon({ className = "", onClick }: SignUpIconProps) {
  return (
    <button
      onClick={onClick}
      className={`h-[31.5px] whitespace-nowrap px-4 text-sm font-medium text-black transition-colors duration-200 hover:text-gray-600 ${className}`}
      aria-label="Log in"
    >
      Log in
    </button>
  );
}
